module.exports = __webpack_public_path__ + "static/img/peopleGame3.5fa4656.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/peopleGame3.png
// module id = 1GxJ
// module chunks = 3